import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import { newPath } from '@/utils/index'
import { SuccessRoot } from './css'

const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();

  useEffect(() => {
    
  }, [])

  return (
    <SuccessRoot className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[2].name} />
      <div className="content">
        <div className="apply">
          <h2>Thank you!</h2>
          <h3>Your response has been submitted.</h3>
          <div className="desc">
            <p>Due to the high demand, we will endeavor to evaluate your application as soon as possible.</p>
          </div>
          <div className="actions">
            <a className="filled-red to-apply" onClick={() => history.push(`${newPath}/ambassador`)}>Back</a>
          </div>
        </div>
      </div>
    </SuccessRoot>
  )
}

export default withRouter(inject("store")(observer(Index)))